/**
 * Created by DSadler on 12/04/2017.
 */
import Editor from './Editor';

export default Editor;


// WEBPACK FOOTER //
// ./src/App/Editor/index.js